import { RemoveFoodLogResponseModel } from './../../../core/model/api-response/food-log-response-model';
import {
  ResponseAddActivityLog,
  AddActivityLogParams,
  updateExercise,
} from './../../../core/model/object/exercise-model';
import { ExerciseLogService } from './exercise-log.service';
import {
  ExerciseItem,
  ResponseDayLogs,
} from './../../../core/model/api-response/plans-response-model';
import { GenericResponse, GenericResponseData } from './../generic-response';
import { baseUrl } from './../../../global-variables';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserDataService } from '../user-repository/user-data.service';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';
import { ExerciseSearchResponce } from 'src/app/core/model/api-response/plans-response-model';

@Injectable({
  providedIn: 'root',
})
export class ExerciseService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private userRefreshTokenService: UserRefreshTokenService,
    private exerciseLog: ExerciseLogService,
    private exerciseLogService: ExerciseLogService
  ) {}
  searchExercise(searchQ: string): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<ExerciseSearchResponce>(
        baseUrl + 'api/v2/exercise/search?name=' + searchQ,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((res) => {
        return new GenericResponse(
          true,
          new GenericResponseData({ exerciseSearchResponce: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.searchExercise(searchQ);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  getTodayExercise(date: number): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();

    return this.http
      .get<ResponseDayLogs>(
        baseUrl + `api/v2/logs?date=${date}&exerciseUpdatedAt=${date}`,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res: ResponseDayLogs) => {
        const data = await this.exerciseLogService.getDayExercises(
          this.exerciseLogService.CDate
            ? this.exerciseLogService.CDate
            : new Date(new Date().setHours(0, 0, 1, 0)).getTime()
        );

        if (
          data &&
          data.exerciseLogs.length > 0 &&
          res.exerciseLogs.length !== 0
        ) {
          await this.exerciseLog.updateExerciseLogs(res.exerciseLogs, date);
        } else if (
          data &&
          data.exerciseLogs.length > 0 &&
          res.exerciseLogs.length === 0
        ) {
          await this.exerciseLog.saveExerciseLogs(null, date);
        } else {
          await this.exerciseLog.saveExerciseLogs(res.exerciseLogs, date);
        }
        if (res.deletedExerciseLogs && res.deletedExerciseLogs.length !== 0) {
          await this.exerciseLog.removeSignleExerciseLogs(
            date,
            res.deletedExerciseLogs
          );
        }
        return new GenericResponse(
          true,
          new GenericResponseData({ responseDayLogs: res.exerciseLogs })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getTodayExercise(date);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  addActivityLog(data: AddActivityLogParams[]) {
    const headerDict = this.userDataService.getHeaderDict();
    data = data.map((el) => {
      if (!el.exercise) {
        delete el.exercise;
      }
      return el;
    });

    return this.http
      .post<ResponseAddActivityLog>(
        baseUrl + 'api/v2/personal/exercise',
        data,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then(async (res) => {
        const date = this.exerciseLogService.CDate
          ? this.exerciseLogService.CDate
          : new Date(new Date().setHours(0, 0, 1, 0)).getTime();
        const data = await this.exerciseLogService.getDayExercises(date);
        if (
          data &&
          data.exerciseLogs.length > 0 &&
          res.exerciseLogs.length !== 0
        ) {
          await this.exerciseLog.updateExerciseLogs(res.exerciseLogs, date);
        } else if (
          data &&
          data.exerciseLogs.length > 0 &&
          res.exerciseLogs.length === 0
        ) {
          await this.exerciseLog.saveExerciseLogs(null, date);
        } else {
          await this.exerciseLog.saveExerciseLogs(res.exerciseLogs, date);
        }
        return new GenericResponse(
          true,
          new GenericResponseData({ addActivityLog: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.addActivityLog(data);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
  updateExercise(id: string, calorie: number, duration?: number) {
    const headerDict = this.userDataService.getHeaderDict();
    let data = { id, calorie, duration };
    if (!duration) {
      delete data.duration;
    }
    return this.http
      .patch<updateExercise>(baseUrl + 'api/v2/personal/exercise/' + id, data, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then(async (res) => {
        if (res.exerciseLog) {
          await this.exerciseLog.updateExerciseLogs(
            [res.exerciseLog],
            this.exerciseLogService.CDate
              ? this.exerciseLogService.CDate
              : new Date(new Date().setHours(0, 0, 1, 0)).getTime()
          );
        }
        return new GenericResponse(
          true,
          new GenericResponseData({ updateExercise: res })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.updateExercise(id, calorie, duration);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }

  deleteExercise(ids: string[]): Promise<GenericResponse> {
    let response: GenericResponse;
    const headerDict = this.userDataService.getHeaderDict();
    const options = {
      headers: new HttpHeaders(headerDict),
      body: {
        ids,
      },
    };
    return this.http
      .delete<RemoveFoodLogResponseModel>(
        baseUrl + 'api/v2/personal/exercise',
        options
      )
      .toPromise()
      .then(async (res) => {
        await this.exerciseLog.removeSignleExerciseLogs(
          this.exerciseLogService.CDate
            ? this.exerciseLogService.CDate
            : new Date(new Date().setHours(0, 0, 1, 0)).getTime(),
          ids
        );

        return new GenericResponse(
          res.success,
          new GenericResponseData({ message: res.message })
        );
      })
      .catch((e) => {
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.deleteExercise(ids);
            }
          });
        }
        response = new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
        return response;
      });
  }
  addTohistory(item: ExerciseItem) {
    const exercise = localStorage.getItem('exercise');
    if (exercise) {
      const exercises = JSON.parse(exercise);
      const names = exercises.map((el) => el.name);
      if (!names.includes(item.name)) {
        if (exercises.length < 10) {
          localStorage.setItem(
            'exercise',
            `${JSON.stringify([...exercises, item])}`
          );
        } else {
          exercises.shift();
          localStorage.setItem(
            'exercise',
            `${JSON.stringify([...exercises, item])}`
          );
        }
      }
    } else {
      localStorage.setItem('exercise', `${JSON.stringify([item])}`);
    }
  }
  getHistory() {
    return JSON.parse(localStorage.getItem('exercise'));
  }
  removeHistory(item: ExerciseItem) {
    const exercise = localStorage.getItem('exercise');
    if (exercise) {
      const exercises: ExerciseItem[] = JSON.parse(exercise);
      const newExercise = exercises.filter((i) => i._id !== item._id);
      localStorage.setItem('exercise', `${JSON.stringify([...newExercise])}`);
    }
  }
}
